import React, { useState, useEffect } from 'react';
import './style.css';
import { HeaderCardapio } from '../../../Components/HeaderCardapio';
import ContadorCarrinho from '../../../Components/ContadorCarrinho';
import Cookies from 'universal-cookie';
import { useParams, useLocation, Link } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';
import { useCart } from '../../../CartContext';
import { useGlobal } from '../../../GlobalContext';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import ProgressiveImage from '../../../Components/ProgressiveImage';
import produtoSemImagem from '../../../Assets/produto-sem-imagem.png';
import { isCardapioOnly, getCardapioReturnUrl } from '../../../Utills/cardapioNavigation';
import { resolveClientColor } from '../../../Utills/colors';

const { REACT_APP_URL_API } = process.env;

const style = {
  position: 'absolute',
  display: 'flex',
  justifyContent: 'center',
  textAlign: 'center',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'var(--background)',
  border: '2px solid var(--title)',
  boxShadow: 24,
  p: 4,
};

const createExpiringOrder = (carrinho, valorTotal) => {
  const now = Date.now();

  return {
    id: `order-${now}`,
    items: carrinho.map((item) => ({
      nome: item.item.nome,
      valor: item.valor,
      quantidade: item.quantidade,
    })),
    total: valorTotal,
    timestamp: new Date().toISOString(),
    createdAt: new Date().toISOString(),
    expiresAt: new Date(now + 6 * 60 * 60 * 1000).toISOString(),
    status: 'preparing',
    timeRemaining: 30,
  };
};

const Carrinho = () => {
  let [carrinho, setCarrinho] = React.useState([]);
  const { cliente_id, item_id } = useParams();
  const location = useLocation();
  const [error, setError] = useState(null);
  const itemId = parseInt(item_id, 10);
  const [abrir, setAbrir] = useState(false);
  const [local, setLocal] = useState('');
  const [observacao, setObservacao] = useState('');
  const [internalOrder, setInternalOrder] = useState('12345');
  const [isFinalizing, setIsFinalizing] = useState(false); // 🔹 Estado do loading
  const [isModalFinalizing, setIsModalFinalizing] = useState(false); // 🔹 Estado do loading no modal
  const [itemToDelete, setItemToDelete] = useState(null);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [quantidade, setQuantidade] = useState(1);
  const [adicionaisSelecionados, setAdicionaisSelecionados] = useState([]);
  const { refreshCart } = useCart();
  const { menu } = useGlobal();

  // Busca a imagem do item no menu global pelo nome
  const getItemImage = (cartItem) => {
    if (!menu || !menu.tipo_refeicao) return null;
    const itemNome = cartItem.item?.nome;
    if (!itemNome) return null;
    
    for (const tipo of menu.tipo_refeicao) {
      for (const categoria of (tipo.categoria_cardapio || [])) {
        const found = (categoria.item_cardapio || []).find(
          (i) => i.nome === itemNome
        );
        if (found?.img) return found.img;
      }
      const foundSemCat = (tipo.item_cardapio_sem_cat || []).find(
        (i) => i.nome === itemNome
      );
      if (foundSemCat?.img) return foundSemCat.img;
    }
    return null;
  };

  // Busca o ID do item no cardápio pelo nome
  const getItemCardapioId = (cartItem) => {
    if (!menu || !menu.tipo_refeicao) return null;
    const itemNome = cartItem.item?.nome;
    if (!itemNome) return null;
    
    for (const tipo of menu.tipo_refeicao) {
      for (const categoria of (tipo.categoria_cardapio || [])) {
        const found = (categoria.item_cardapio || []).find(
          (i) => i.nome === itemNome
        );
        if (found) return found.id;
      }
      const foundSemCat = (tipo.item_cardapio_sem_cat || []).find(
        (i) => i.nome === itemNome
      );
      if (foundSemCat) return foundSemCat.id;
    }
    return null;
  };

  const userIp = localStorage.getItem('ip_address');
  const session = localStorage.getItem('session');

  const queryParams = new URLSearchParams(location.search);
  const apartamento = queryParams.get('x');
  const cliente_url = queryParams.get('id_cliente');
  const session_control = queryParams.get('session_control');

  const cookies = new Cookies();
  const token = cookies.get('csrftoken2');
  const [itensRemovidos, setItensRemovidos] = useState([]);

  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const userLanguage = navigator.language || navigator.userLanguage;

  const headers = new Headers({
    'Content-Type': 'application/json',
    'X-CSRFToken': token,
  });

  const body = JSON.stringify({
    cliente_id: cliente_id,
    ip_address: userIp,
    language: userLanguage,
    session: session,
  });

  useEffect(() => {
    window
      .fetch(
        `${REACT_APP_URL_API}/apiv2/cart/?x=${apartamento}&id_cliente=${cliente_url}&session_control=${session_control}`,
        {
          method: 'POST',
          headers: headers,
          body: body,
          credentials: 'omit',
        },
      )
      .then((response) => response.json())
      .then((json) => setCarrinho(json))
      .catch((error) => setError(error));
  }, [cliente_id, apartamento, cliente_url, session, session_control]);

  if (carrinho === null) return null;

  const totalItens = carrinho.reduce((acc, item) => acc + item.quantidade, 0);
  const valorTotal = carrinho.reduce(
    (acc, item) => acc + item.quantidade * item.valor,
    0,
  );

  const incrementarQuantidade = (index) => {
    setCarrinho((prevCarrinho) => {
      const novoCarrinho = [...prevCarrinho];
      const itemId = novoCarrinho[index].id;
      novoCarrinho[index].quantidade += 1;
      handleAddToCart(itemId, novoCarrinho[index].quantidade, 'update');
      return novoCarrinho;
    });
  };

  const decrementarQuantidade = (index) => {
    setCarrinho((prevCarrinho) => {
      const novoCarrinho = [...prevCarrinho];
      const itemId = novoCarrinho[index].id;
      novoCarrinho[index].quantidade -= 1;
      if (novoCarrinho[index].quantidade === 0) {
        deleteCarrinho(index);
      } else {
        handleAddToCart(itemId, novoCarrinho[index].quantidade, 'update');
      }
      return novoCarrinho;
    });
  };

  const deleteCarrinho = (index) => {
    const itemId = carrinho[index].id;
    const novoCarrinho = carrinho.filter((_, i) => i !== index);
    setCarrinho(novoCarrinho);
    handleAddToCart(itemId, 0, 'remove');
  };

  const confirmDeleteCarrinho = () => {
    if (!itemToDelete) return;
    deleteCarrinho(itemToDelete.index);
    setItemToDelete(null);
  };

  const corCliente = resolveClientColor();
  const cor_letra = localStorage.getItem('cliente_cor_letra');

  const handleQuantidadeChange = (novaQuantidade) => {
    setQuantidade(novaQuantidade);
  };

  const handleAdicionaisChange = (adicionalId) => {
    setAdicionaisSelecionados((prevAdicionais) =>
      prevAdicionais.includes(adicionalId)
        ? prevAdicionais.filter((id) => id !== adicionalId)
        : [...prevAdicionais, adicionalId],
    );
  };

  const handleAddToCart = (itemId, quantidade, operation = 'update') => {
    const payload = {
      cliente_id: cliente_id,
      ip_address: userIp,
      session: session,
      operation: operation,
      items: [
        {
          id: itemId,
          quantity: quantidade,
          additional_items: adicionaisSelecionados,
        },
      ],
    };

    fetch(
      `${REACT_APP_URL_API}/apiv2/cart/update/?x=${apartamento}&id_cliente=${cliente_url}&session_control=${session_control}`,
      {
        method: 'POST',
        credentials: 'omit',
        headers: headers,
        body: JSON.stringify(payload),
      },
    )
      .then((response) => response.json())
      .then((data) => {
        console.log(
          `Item ${
            operation === 'remove' ? 'removido' : 'atualizado'
          } no carrinho:`,
          data,
        );
        if (typeof refreshCart === 'function') refreshCart();
        window.dispatchEvent(new Event('cartUpdated'));
      })
      .catch((error) => {
        console.error(
          `Erro ao ${
            operation === 'remove' ? 'remover' : 'atualizar'
          } item do carrinho:`,
          error,
        );
      });
  };

  const handleLocalChange = (event) => {
    setLocal(event.target.value);
  };

  const handleFinalizeOrder = () => {
    const c = queryParams.get('c');

    if (c === 'true') {
      handleOpen();
    } else {
      setIsFinalizing(true); // 🔹 Ativa o loading

      const payload = {
        cliente_id: cliente_id,
        ip_address: userIp,
        session: session,
        operation: 'finish',
      };

      fetch(
        `${REACT_APP_URL_API}/apiv2/cart/update/?x=${apartamento}&id_cliente=${cliente_url}&session_control=${session_control}`,
        {
          method: 'POST',
          credentials: 'omit',
          headers: headers,
          body: JSON.stringify(payload),
        },
      )
        .then((response) => response.json())
        .then((data) => {
          console.log('✅ Pedido finalizado:', data);

          const newOrder = createExpiringOrder(carrinho, valorTotal);
          const existing = JSON.parse(
            localStorage.getItem('activeOrders') || '[]',
          );
          localStorage.setItem(
            'activeOrders',
            JSON.stringify([...existing, newOrder]),
          );

          setShowSuccessMessage(true);
          setTimeout(() => {
            setShowSuccessMessage(false);
            window.location.href = `/${cliente_id}/sucesso/${location.search}`;
          }, 1500);
        })
        .catch((error) => {
          console.error('Erro ao finalizar pedido:', error);
          setIsFinalizing(false); // 🔹 Desativa o loading em caso de erro
          alert('Erro ao finalizar pedido. Tente novamente.');
        });
    }
  };

  const renderAdicionais = (adicionais) => {
    return adicionais.map((item, index) => (
      <div key={index} className="div-opcionais">
        <input
          type="checkbox"
          value={item[0]}
          onChange={() => handleAdicionaisChange(item[0])}
        />
        <p>{item[1]}</p>
      </div>
    ));
  };

  const handleModalFinalizeOrder = () => {
    if (local) {
      setIsModalFinalizing(true);

      const payload = {
        cliente_id: cliente_id,
        ip_address: userIp,
        session: session,
        operation: 'finish',
        local: local,
        observacao: observacao,
        internal_order: internalOrder,
      };

      fetch(
        `${REACT_APP_URL_API}/apiv2/cart/update/?x=${apartamento}&id_cliente=${cliente_url}&session_control=${session_control}`,
        {
          method: 'POST',
          credentials: 'omit',
          headers: headers,
          body: JSON.stringify(payload),
        },
      )
        .then((response) => response.json())
        .then((data) => {
          console.log('✅ Pedido finalizado com local:', data);

          const newOrder = createExpiringOrder(carrinho, valorTotal);
          const existing = JSON.parse(
            localStorage.getItem('activeOrders') || '[]',
          );
          localStorage.setItem(
            'activeOrders',
            JSON.stringify([...existing, newOrder]),
          );

          setShowSuccessMessage(true);
          setTimeout(() => {
            setShowSuccessMessage(false);
            window.location.href = `/${cliente_id}/sucesso/${location.search}`;
          }, 1500);
        })
        .catch((error) => {
          console.error('Erro ao finalizar pedido:', error);
          setIsModalFinalizing(false); // 🔹 Desativa o loading em caso de erro
          alert('Erro ao finalizar pedido. Tente novamente.');
        });
    } else {
      alert('Por favor, insira o número do local.');
    }
  };

  return (
    <div>
      <HeaderCardapio />

      <div className="MainGrid">
        <div className="container_checkout">
          <h1>ITENS NO CARRINHO</h1>

          {carrinho.map((item, index) => {
            let arrayAdicionais = [];

            console.log(
              'Valor original de array_adicionais:',
              item.array_adicionais,
            );

            if (Array.isArray(item.array_adicionais)) {
              arrayAdicionais = item.array_adicionais;
            } else if (typeof item.array_adicionais === 'string') {
              const formattedAdicionais = item.array_adicionais.replace(
                /'/g,
                '"',
              );
              if (
                formattedAdicionais.startsWith('[') &&
                formattedAdicionais.endsWith(']')
              ) {
                try {
                  arrayAdicionais = JSON.parse(formattedAdicionais);
                } catch (e) {
                  console.error('Erro ao converter array_adicionais:', e);
                }
              }
            }

            console.log('Array convertido de adicionais:', arrayAdicionais);

            return (
              <div
                key={index}
                className="div_itens_carrinho"
              >
                {/* Miniatura da foto do prato */}
                <Link
                  to={`/${cliente_id}/cardapioitem/${getItemCardapioId(item) || ''}${location.search}`}
                  className="cart-item-link"
                >
                  <div className="cart-item-thumbnail">
                    {(() => {
                      const img = getItemImage(item);
                      return img ? (
                        <img
                          src={`${REACT_APP_URL_API}${img}`}
                          alt={item.item?.nome}
                          className="cart-item-img"
                          loading="lazy"
                        />
                      ) : (
                        <img
                          src={produtoSemImagem}
                          alt="Sem imagem"
                          className="cart-item-img cart-item-img--sem-imagem"
                          loading="lazy"
                        />
                      );
                    })()}
                  </div>
                </Link>

                <Link
                  to={`/${cliente_id}/cardapioitem/${getItemCardapioId(item) || ''}${location.search}`}
                  className="cart-item-link cart-item-info"
                >
                  <p className="cart-item-name">{item.item.nome}</p>
                  {Array.isArray(arrayAdicionais) &&
                  arrayAdicionais.length > 0 ? (
                    <div className="cart-item-adicionais">
                      <p className="adicionas__carrinho__title">
                        Itens adicionais:
                      </p>
                      {arrayAdicionais.map((adicional, idx) => (
                        <p key={idx} className="adicionas__carrinho">
                          {adicional}
                        </p>
                      ))}
                    </div>
                  ) : null}
                </Link>

                <div className="cart-item-actions">
                  <ContadorCarrinho
                    quantidade={item.quantidade}
                    onIncrement={() => incrementarQuantidade(index)}
                    onDecrement={() => decrementarQuantidade(index)}
                  />
                </div>

                <div className="cart-item-price-delete">
                  <p className="cart-item-price">
                    {`R$${(
                      item.quantidade * parseFloat(item.valor)
                    ).toLocaleString('pt-BR', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}`}
                  </p>

                  <button
                    className="cart-item-delete-btn"
                    onClick={() => setItemToDelete({ index, item })}
                    aria-label={`Excluir ${item.item?.nome || 'item'} do carrinho`}
                  >
                    <DeleteIcon fontSize="small" />
                  </button>
                </div>
              </div>
            );
          })}
        </div>

        <div
          className="container_checkout div-checkout"
          style={{ marginTop: '40px' }}
        >
          <h1>DETALHES</h1>
          <div className="div_itens_carrinho">
            <p>Total de itens</p>
            <p>{totalItens}</p>
          </div>

          <div className="div_itens_carrinho">
            <p>
              <b>Valor Total</b>
            </p>
            <p>
              <b>{` R$${valorTotal.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}`}</b>
            </p>
          </div>
        </div>
        <div className="div-btn-carrinho">
          <button
            className="btn-finalizar-pedido"
            style={{
              background: corCliente,
              color: cor_letra,
              opacity: isFinalizing ? 0.7 : 1,
              cursor: isFinalizing ? 'not-allowed' : 'pointer',
            }}
            onClick={() => {
              if (!isFinalizing) {
                if (totalItens > 0) {
                  handleFinalizeOrder();
                } else {
                  window.location.href = isCardapioOnly(location.search)
                    ? getCardapioReturnUrl(cliente_id, location.search)
                    : `/${cliente_id}/cardapio/tipo/${location.search}`;
                }
              }
            }}
            disabled={isFinalizing}
          >
            {isFinalizing ? (
              <>
                <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} />
                Finalizando...
              </>
            ) : totalItens > 0 ? (
              `Finalizar Pedido R$${valorTotal.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}`
            ) : (
              'Voltar ao Cardápio'
            )}
          </button>
        </div>
      </div>

      {showSuccessMessage && (
        <Alert
          severity="success"
          icon={<CheckIcon fontSize="inherit" />}
          sx={{
            position: 'fixed',
            bottom: 20,
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 9999,
            minWidth: 300,
          }}
        >
          Pedido enviado com sucesso!
        </Alert>
      )}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="container-modal" style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <h2 style={{ padding: '10px' }}>Finalizar Pedido</h2>
            <p style={{ fontSize: '14px', color: '#666' }}>
              Informe o número do quarto ou mesa para enviar o pedido.
            </p>
            <input
              type="text"
              value={local}
              onChange={handleLocalChange}
              placeholder="Nº do quarto ou mesa *"
              className="input__local__carrinho"
              disabled={isModalFinalizing}
              style={{ width: '100%', boxSizing: 'border-box' }}
            />
            <textarea
              value={observacao}
              onChange={(e) => setObservacao(e.target.value)}
              placeholder="Observação (opcional)"
              className="input__local__carrinho"
              disabled={isModalFinalizing}
              rows={3}
              style={{ width: '100%', boxSizing: 'border-box', resize: 'vertical', minHeight: '70px' }}
            />
            {!local && (
              <p style={{ fontSize: '12px', color: '#e74c3c', margin: '0' }}>
                * Campo obrigatório
              </p>
            )}
            <button
              className="btn-finalizar-pedido-modal"
              style={{
                background: corCliente,
                color: cor_letra,
                opacity: isModalFinalizing || !local ? 0.7 : 1,
                cursor: isModalFinalizing || !local ? 'not-allowed' : 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
              }}
              onClick={handleModalFinalizeOrder}
              disabled={isModalFinalizing || !local}
            >
              {isModalFinalizing ? (
                <>
                  <CircularProgress size={20} color="inherit" />
                  Finalizando...
                </>
              ) : (
                'Finalizar Pedido'
              )}
            </button>
          </div>
        </Box>
      </Modal>

      <Modal
        open={itemToDelete !== null}
        onClose={() => setItemToDelete(null)}
        aria-labelledby="confirm-delete-title"
        aria-describedby="confirm-delete-description"
      >
        <Box className="cart-delete-confirmation">
          <h2 id="confirm-delete-title">Excluir item?</h2>
          {itemToDelete?.item && (
            <div className="cart-delete-confirmation__item">
              <div className="cart-delete-confirmation__thumbnail">
                <img
                  src={(() => {
                    const image = getItemImage(itemToDelete.item);
                    return image ? `${REACT_APP_URL_API}${image}` : produtoSemImagem;
                  })()}
                  alt=""
                  onError={(event) => { event.currentTarget.src = produtoSemImagem; }}
                />
              </div>
              <p>{itemToDelete.item.item?.nome || 'Item do carrinho'}</p>
            </div>
          )}
          <p id="confirm-delete-description">
            Deseja mesmo excluir este item do carrinho?
          </p>
          <div className="cart-delete-confirmation__actions">
            <button
              type="button"
              className="cart-delete-confirmation__cancel"
              onClick={() => setItemToDelete(null)}
            >
              Cancelar
            </button>
            <button
              type="button"
              className="cart-delete-confirmation__confirm"
              onClick={confirmDeleteCarrinho}
            >
              Excluir
            </button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default Carrinho;
